import { render, staticRenderFns } from "./applicant.component.vue?vue&type=template&id=0c75e8e4"
import script from "./applicant.component.vue?vue&type=script&lang=ts"
export * from "./applicant.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports